// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
export class CustomError extends Error {
  name = 'UnknownError'
  statusCode = 500
  error: unknown

  constructor(message?: string, name?: string, statusCode?: number, error?: unknown) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype) // restore prototype chain

    if (name) this.name = name
    if (statusCode) this.statusCode = statusCode
    this.error = error
  }
}
